import React, { useState } from 'react'
import './Jobs.css'
import emailjs from '@emailjs/browser';

const Jobs = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    howDidYouHear: '',
    authorization: '',
    linkedin: '',
    instagram: '',
    facebook: '',
    twitter: '',
    other: '',
    reference1Name: '',
    reference1Relationship: '',
    reference1Contact: '',
    reference2Name: '',
    reference2Relationship: '',
    reference2Contact: '',
    reference3Name: '',
    reference3Relationship: '',
    reference3Contact: '',
    resume: null,
  });

  const [status, setStatus] = useState({
    message: '',
    isError: false,
    isSubmitting: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleFileChange = (e) => {
    setFormData(prevState => ({
      ...prevState,
      resume: e.target.files[0]
    }));
  };

  const uploadFile = async (file) => {
    const formDataUpload = new FormData();
    formDataUpload.append('file', file);
    formDataUpload.append('upload_preset', 'malaika_doula_cvs');
    formDataUpload.append('api_key', '599871839653756'); // Add this line

    try {
      const response = await fetch(
        `https://api.cloudinary.com/v1_1/malaika_doula_cvs/auto/upload`,
        {
          method: 'POST',
          body: formDataUpload,
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Cloudinary error: ${errorData.error?.message || response.statusText}`);
      }

      const data = await response.json();
      return data.secure_url;
    } catch (error) {
      throw new Error(`File upload failed: ${error.message}`);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!formData.firstName || !formData.lastName || !formData.email || !formData.phone || !formData.address || !formData.city || !formData.state || !formData.zipCode || !formData.howDidYouHear || !formData.authorization || !formData.reference1Name || !formData.reference1Relationship || !formData.reference1Contact) {
      setStatus({
        message: 'Please fill in all required fields',
        isError: true,
        isSubmitting: false
      });
      return;
    }

    setStatus({
      message: 'Submitting your application...',
      isError: false,
      isSubmitting: true
    });

    try {
      let resumeUrl = 'Not provided';
      if (formData.resume) {
        setStatus({
          message: 'Uploading resume...',
          isError: false,
          isSubmitting: true
        });
        resumeUrl = await uploadFile(formData.resume);
      }

      const templateParams = {
        from_name: `${formData.firstName} ${formData.lastName}`,
        from_email: formData.email,
        phone: formData.phone,
        address: formData.address,
        city: formData.city,
        state: formData.state,
        zip_code: formData.zipCode,
        how_did_you_hear: formData.howDidYouHear,
        authorization: formData.authorization,
        linkedin: formData.linkedin || 'Not provided',
        instagram: formData.instagram || 'Not provided',
        facebook: formData.facebook || 'Not provided',
        twitter: formData.twitter || 'Not provided',
        other_social: formData.other || 'Not provided',
        reference1_name: formData.reference1Name,
        reference1_relationship: formData.reference1Relationship,
        reference1_contact: formData.reference1Contact,
        reference2_name: formData.reference2Name || 'Not provided',
        reference2_relationship: formData.reference2Relationship || 'Not provided',
        reference2_contact: formData.reference2Contact || 'Not provided',
        reference3_name: formData.reference3Name || 'Not provided',
        reference3_relationship: formData.reference3Relationship || 'Not provided',
        reference3_contact: formData.reference3Contact || 'Not provided',
        resume: resumeUrl,
      };

      setStatus({
        message: 'Sending application...',
        isError: false,
        isSubmitting: true
      });

      await emailjs.send(
        'service_5tqzyv3',
        'template_xg1f7ke',
        templateParams,
        'gv3wXk_3A6CaX8X6Q'
      );

      setStatus({
        message: 'Thank you for your application. We will get back to you soon!',
        isError: false,
        isSubmitting: false
      });

      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        address: '',
        city: '',
        state: '',
        zipCode: '',
        howDidYouHear: '',
        authorization: '',
        linkedin: '',
        instagram: '',
        facebook: '',
        twitter: '',
        other: '',
        reference1Name: '',
        reference1Relationship: '',
        reference1Contact: '',
        reference2Name: '',
        reference2Relationship: '',
        reference2Contact: '',
        reference3Name: '',
        reference3Relationship: '',
        reference3Contact: '',
        resume: null,
      });

    } catch (error) {
      setStatus({
        message: `Error: ${error.message}. Please try again.`,
        isError: true,
        isSubmitting: false
      });
    }
  }

  return (
    <div>
      <form className='jobs-form-container' onSubmit={handleSubmit}>
        <h3>Personal Details</h3>

        <input type="text" placeholder='First Name' name="firstName" value={formData.firstName} onChange={handleChange} required disabled={status.isSubmitting} />
        <input type="text" placeholder='Last Name' name="lastName" value={formData.lastName} onChange={handleChange} required disabled={status.isSubmitting} />
        <input type="email" placeholder='Email' name="email" value={formData.email} onChange={handleChange} required disabled={status.isSubmitting} />
        <input type="tel" placeholder='Cell Phone Number' name="phone" value={formData.phone} onChange={handleChange} required disabled={status.isSubmitting} />
        <input type='text' placeholder='Address' name="address" value={formData.address} onChange={handleChange} required disabled={status.isSubmitting} />
        <input type="text" placeholder='City' name="city" value={formData.city} onChange={handleChange} required disabled={status.isSubmitting} />
        <input type="text" placeholder='State' name="state" value={formData.state} onChange={handleChange} required disabled={status.isSubmitting} />
        <input type="text" placeholder='Zip Code' name="zipCode" value={formData.zipCode} onChange={handleChange} required disabled={status.isSubmitting} />
        <input type="text" placeholder='How did you hear about us?' name="howDidYouHear" value={formData.howDidYouHear} onChange={handleChange} required disabled={status.isSubmitting} />

        <h3>Professional Details</h3>
        <label htmlFor='authorization'>Are you authorized to work in the United States?</label><br />
        Yes
        <input type='radio' id='authorized' name='authorization' value='Yes' checked={formData.authorization === 'Yes'} onChange={handleChange} required disabled={status.isSubmitting} />
        No
        <input type='radio' id='not-authorized' name='authorization' value='No' checked={formData.authorization === 'No'} onChange={handleChange} required disabled={status.isSubmitting} />
        <p>Please list the links or handles to your social media profiles:</p>
        <input type="text" placeholder='LinkedIn' name="linkedin" value={formData.linkedin} onChange={handleChange} disabled={status.isSubmitting} />
        <input type="text" placeholder='Instagram' name="instagram" value={formData.instagram} onChange={handleChange} disabled={status.isSubmitting} />
        <input type="text" placeholder='Facebook' name="facebook" value={formData.facebook} onChange={handleChange} disabled={status.isSubmitting} />
        <input type="text" placeholder='Twitter' name="twitter" value={formData.twitter} onChange={handleChange} disabled={status.isSubmitting} />
        <input type="text" placeholder='Other' name="other" value={formData.other} onChange={handleChange} disabled={status.isSubmitting} />

        <h3>Professional and Relevant References</h3>
        <p>You must list at least three professional and relevant references from your most recent positions.</p>
        <p>Please, only list references from paid professional of relevant positions that were held over the age of 18.</p>

        <p className='underline'>Reference 1</p> 
        <input type="text" placeholder='Reference 1 Name' name="reference1Name" value={formData.reference1Name} onChange={handleChange} required disabled={status.isSubmitting} />
        <input type="text" placeholder='Reference 1 Relationship to You' name="reference1Relationship" value={formData.reference1Relationship} onChange={handleChange} required disabled={status.isSubmitting} />
        <input type="text" placeholder='Reference 1 Contact Information' name="reference1Contact" value={formData.reference1Contact} onChange={handleChange} required disabled={status.isSubmitting} />

        <p className='underline'>Reference 2</p>
        <input type="text" placeholder='Reference 2 Name' name="reference2Name" value={formData.reference2Name} onChange={handleChange} required disabled={status.isSubmitting} />
        <input type="text" placeholder='Reference 2 Relationship to You' name="reference2Relationship" value={formData.reference2Relationship} onChange={handleChange} required disabled={status.isSubmitting} />
        <input type="text" placeholder='Reference 2 Contact Information' name="reference2Contact" value={formData.reference2Contact} onChange={handleChange} required disabled={status.isSubmitting} />

        <p className='underline'>Reference 3</p>
        <input type="text" placeholder='Reference 3 Name' name="reference3Name" value={formData.reference3Name} onChange={handleChange} required disabled={status.isSubmitting} />
        <input type="text" placeholder='Reference 3 Relationship to You' name="reference3Relationship" value={formData.reference3Relationship} onChange={handleChange} required disabled={status.isSubmitting} />
        <input type="text" placeholder='Reference 3 Contact Information' name="reference3Contact" value={formData.reference3Contact} onChange={handleChange} required disabled={status.isSubmitting} />

        <p>Please upload your professional and relevant resume:</p>
        <input type="file" name="resume" onChange={handleFileChange} disabled={status.isSubmitting} />

        {status.message && (
          <div className={`status-message ${status.isError ? 'error' : 'success'}`}>
            {status.message}
          </div>
        )}
        <button type='submit' disabled={status.isSubmitting}>
          {status.isSubmitting ? 'Submitting...' : 'Submit'}
        </button>
      </form>
    </div>
  );

};

export default Jobs